// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { PermissionEffects } from './store/effects';
import * as fromPermission from './store/reducer';

// SERVICES
import { PermissionStoreService } from './permission-store.service';
import { PermissionService } from './services/permission.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: [], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure master permission ngrx related stuff.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 27-04-2020 master permission store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('permission', fromPermission.reducer, { metaReducers }),
    EffectsModule.forFeature([PermissionEffects]),
  ],
  declarations: [],
  providers: [
    PermissionService,
    PermissionStoreService,
  ],
})
export class PermissionStoreModule { }
